import Alpine from 'alpinejs'

Alpine.data('variantSelect', (
    variantLabels: object,
    selectedVariantId: string|null,
    dropDownDirectionScrollContainer: string
) => ({

    selectedVariantId: selectedVariantId || null,
    isOpen: false,
    dropdownDirectionDown: true,

    // internal
    isKeepOpen: false,
    scrollContainer: document,
    viewportHeight: null,
    minDistanceForDropDownDirectionChange: 100,

    init() {
        if(this.selectedVariantId) {
            this.$dispatch('variant-selected', this.selectedVariantId)
        }
        this.$watch('selectedVariantId', (variantId) => {
            this.$dispatch('variant-selected', variantId)
            this.close()
        })

        // resize / dropdown direction decision

        if(Object.keys(variantLabels).length > 1) {

            this.viewportHeight = document.documentElement.clientHeight

            if(dropDownDirectionScrollContainer) {
                this.scrollContainer = document.querySelector(dropDownDirectionScrollContainer)
            }
            this.scrollContainer.addEventListener('scroll', () => this.onScroll(), { passive: true })
            window.addEventListener('resize', () => this.onResize(), { passive: true })

            this.decideDropDownDirection()
        }
    },

    decideDropDownDirection() {
        if(!this.$refs.dropDownAnchor) { // single variant does not have a dropdown
            return
        }
        
        // decide in which direction to put the dropdown
        // chose opposite of whichever side is closer to top/bottom
        // but only switch again when the distance between top/bottom exceeds a minimum

        const rect = this.$refs.dropDownAnchor.getBoundingClientRect()
        const bottomDistance = this.viewportHeight - rect.bottom

        if( this.dropdownDirectionDown &&
            bottomDistance < rect.top &&
            rect.top-bottomDistance > this.minDistanceForDropDownDirectionChange
        ) {
            this.dropdownDirectionDown = false
        }
        if( !this.dropdownDirectionDown &&
            bottomDistance > rect.top &&
            bottomDistance-rect.top > this.minDistanceForDropDownDirectionChange
        ) {
            this.dropdownDirectionDown = true
        }
    },

    onScroll() {
        this.decideDropDownDirection()
    },

    onResize() {
        this.viewportHeight = document.documentElement.clientHeight
        this.onScroll()
    },

    currentVariantLabel() {
        return variantLabels[this.selectedVariantId] || ''
    },
    
    selectVariant(variantId) {
        if(variantLabels[variantId]) {
            this.selectedVariantId = variantId
        }
    },

    toggle() {
        this.isOpen = !this.isOpen
    },

    open() {
        this.isOpen = true
    },

    close() {
        this.isOpen = false
    },

    closeIfNotKeepOpen() {
        if(this.isKeepOpen) {
            this.isKeepOpen = false
            return
        }
        this.isOpen = false
    },

    keepOpen() {
        this.open()
        this.isKeepOpen = true
    }
}))